import React from 'react'
import Navbar from '../inc/Navbar'
import PrintApplication from './PrintApplication'
import ScrollToTop from "react-scroll-to-top"

import {Link } from "react-router-dom";

function Printpage() {
  return (
    <div>
         <Navbar/>
    <br/>
    <br/>
    <br/>
      <ScrollToTop smooth top="100" color="Gray" />
    <div className='color'>
          <div className="album py-1">

                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/"> Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Print Your Application</li>
                            </ol>
                        </nav>
                    </div>
                </div>
                </div>
                <PrintApplication/>
    </div>
  )
}

export default Printpage